// The typed client from packages/schema, wired to the session and the offline queue.
import { createApiClient } from '@roots/schema';
import { API_URL, readToken } from './auth.js';
import { queueAction } from './offline.js';

export const api = createApiClient({
  baseUrl: API_URL,
  getToken: () => readToken(),
});

export type Api = typeof api;

/**
 * App Flow §7.3 — actions that need the server are queued when offline and replayed
 * on reconnect. Reads fall back to the Dexie cache in the query layer.
 */
export async function withQueue<T>(
  action: { kind: string; payload: unknown },
  run: () => Promise<T>,
): Promise<T | null> {
  if (typeof navigator !== 'undefined' && !navigator.onLine) {
    await queueAction(action.kind, action.payload);
    return null;
  }
  try {
    return await run();
  } catch (err) {
    if (typeof navigator !== 'undefined' && !navigator.onLine) {
      await queueAction(action.kind, action.payload);
      return null;
    }
    throw err;
  }
}
